var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOverdrive = function SvgOverdrive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 23 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.538 9.818V3.773h-1v6.045zM9.356 7.591h2.091V3.773h1V7.59h2.091v1H9.356zM19.357 11.546V3.773h-1v7.773zM12.447 19.319v-7.773h-1v7.773zM2.447 13.773h2.091v5.546h1v-5.546H7.63v-1H2.447zM16.266 15.5h2.09v3.819h1V15.5h2.091v-1h-5.181z"
  })));
};
export default SvgOverdrive;